import { createPropsSelectorModel, createSelector } from 'react-scoped-model';

interface IProps {
  title: string;
  description: string;
}

export const RestrictedInfo = createPropsSelectorModel<IProps>({
  displayName: 'Models.RestrictedInfo',
});

export const useRestrictedInfoTitle = createSelector(
  RestrictedInfo,
  (state) => state.title,
);

export const useRestrictedInfoDescription = createSelector(
  RestrictedInfo,
  (state) => state.description,
);
